module.exports = "/assets/js/2dcabfad5a2e921014327eea55f3830f.svg";